import { FC, useState, useCallback } from 'react'
import { useStoreDispatch } from 'helpers/reactReduxHelpers'
import { unlinkCarActionCreator } from 'actions/propertyActions'
import moment from 'moment'
import ConfirmModalComponent from 'components/features/pfm/ConfirmModal/ConfirmModal'

type CarUnlinkHandlerProps = {
  carId: number
  onConfirm?: () => void
}

export const CarUnlinkHandler: FC<CarUnlinkHandlerProps> = (props) => {
  const { children, carId, onConfirm } = props

  const [isConfirmShown, setIsConfirmShown] = useState(false)
  const showConfirm = useCallback(() => setIsConfirmShown(true), [])
  const hideConfirm = useCallback(() => setIsConfirmShown(false), [])

  const dispatch = useStoreDispatch()
  const handleConfirm = useCallback(() => {
    hideConfirm()
    dispatch(unlinkCarActionCreator(carId, moment().toISOString()))
    onConfirm && onConfirm()
  }, [dispatch, carId, hideConfirm, onConfirm])

  return (
    <>
      <span onClick={ showConfirm }>
        { children }
      </span>
      { isConfirmShown && (
        <ConfirmModalComponent onCancel={ hideConfirm } onConfirm={ handleConfirm } confirmButtonText='Unlink'>
          Unlinking this car preserves its historical data, but removes it from current and future assets. Are you sure you want to unlink this car?
        </ConfirmModalComponent>
      )}
    </>
  )
}
